import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import style from './Carousel.module.css';
import { getScreenLink } from '../../utils/api';
import { connect } from 'react-redux';

// todo: 准备lol宇宙那种播放方案作为备选
// todo: 添加按键支持 space/left/right/number
// todo: 合并next prev 执行次数

var throttle = function (func: any, delay: number) {
  var prev = Date.now();
  return function (...args: any[]) {
    var context = this;
    var now = Date.now();
    if (now - prev >= delay) {
      func.apply(context, args);
      prev = Date.now();
    }
  };
};

function usePlayAnimate({ show, interval, totalLength, size }: { show: boolean; interval: number; totalLength: number; size: number }) {
  const [playIndex, setPlayIndex] = useState(0);
  // todo: 加个动画方向
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (show) {
      timer = setInterval(next, interval);
    }
    return () => {
      clearInterval(timer);
    };
  }, [show, interval, totalLength, size, playIndex]);

  let i = _prev(playIndex, totalLength, Math.floor(size / 2));
  let indexRange: number[] = [];
  Array.from({ length: size }).forEach((d, ii) => {
    indexRange.push(i);
    if (i === totalLength - 1) i = 0;
    else i++;
  });

  function _next(i: number, length: number) {
    if (i >= length - 1) return 0;
    return i + 1;
  }

  function _prev(i: number, length: number, step: number = 1) {
    let _i = i;
    const s = (i: number) => {
      if (i <= 0) return length - 1;
      return i - 1;
    };
    for (let c = 0; c < step; c++) {
      _i = s(_i);
    }
    return _i;
  }

  const next = useCallback(
    throttle(() => {
      return setPlayIndex(_next(playIndex, totalLength));
    }, 500),
    [playIndex, totalLength]
  );

  const prev = useCallback(
    throttle(() => {
      setPlayIndex(_prev(playIndex, totalLength));
    }, 500),
    [playIndex, totalLength]
  );

  return { playIndex, indexRange, next, prev, toIndex: throttle(setPlayIndex, 200) };
}

interface CarouselProps {
  list: Cockpit.Screen[];
  width: number;
  height: number;
}

function _Carousel(props: CarouselProps & { meaturement: { width: number; height: number }; onClick(id: string): void }) {
  let { list, width, height, meaturement, onClick: onView } = props;
  const imageMeasurement = { ...meaturement };

  let showCount = list.length;
  if (showCount === 2) {
    showCount = 3;
    list = list.concat(list[0]);
  }
  showCount = showCount % 2 === 1 ? showCount : showCount - 1;
  showCount = 5 > showCount ? showCount : 5;

  const { indexRange, next, prev, toIndex } = usePlayAnimate({
    show: false,
    interval: 3e3,
    totalLength: list.length,
    size: showCount
  });

  const midIndex = Math.floor(showCount / 2);
  const middle = indexRange[midIndex];
  const brightness = '60%';
  const backDown = '0%';
  const backScale = 0.8;
  const backCount = Math.floor((showCount - 1) / 2);
  const sideWidth = backCount * 30;
  const handleWidth = 150;
  width = width - handleWidth * 2; // 去除两边抓手后宽度
  const hotzoneWidth = handleWidth + sideWidth;

  if (imageMeasurement.height > height) {
    const scale = height / imageMeasurement.height;
    imageMeasurement.height = height;
    imageMeasurement.width = imageMeasurement.width * scale;
  }
  if (imageMeasurement.width > width) {
    const scale = width / imageMeasurement.width;
    imageMeasurement.width = width;
    imageMeasurement.height = imageMeasurement.height * scale;
  }

  const scale = (imageMeasurement.width - sideWidth * 2) / imageMeasurement.width;
  const marginLeft = (width - imageMeasurement.width * scale) / 2;

  let onClick = () => {};
  return (
    <React.Fragment>
      <span className={classnames(style.handle_left)}></span>
      <span className={classnames(style.handle_right)}></span>

      <div
        style={{
          width,
          height: imageMeasurement.height,
          position: 'absolute',
          zIndex: 2,
          margin: 'auto',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }}
      >
        <span className={classnames(style.hotzone)} style={{ width: hotzoneWidth, left: -handleWidth }} onClick={prev}></span>
        <span className={classnames(style.hotzone)} style={{ width: hotzoneWidth, right: -handleWidth }} onClick={next}></span>
        {list.map((screen, index) => {
          const id = screen.id;
          const innerStyle: any = {
            ...imageMeasurement,
            filter: `brightness(${brightness})`,
            position: 'absolute',
            transformOrigin: 'left',
            transition: 'all .4s ease-in-out',
            transform: 'scale(0.5) translateX(100%)'
          };

          if (~indexRange.indexOf(index)) {
            // 居中图片
            if (index === middle) {
              innerStyle.transform = `scale(${scale})`;
              innerStyle.left = marginLeft;
              innerStyle.zIndex = backCount;
              innerStyle.visibility = 'visible';
              innerStyle.opacity = '1';
              innerStyle.filter = 'brightness(100%)';
              onClick = () => onView(screen.id);
            } else {
              const pos = indexRange.indexOf(index);
              const distance = Math.abs(midIndex - pos);
              const direction = pos > midIndex ? 'right' : 'left';
              const scale = 1 - (distance / (backCount + 1)) * backScale;
              const base = width / 2;
              // const left =  (1 - distance / backCount) * 0.35 * base;
              const left = marginLeft * (1 - distance / backCount);
              if (direction === 'left') {
                // 左侧图片
                innerStyle.transform = `scale(${scale}) translateY(${backDown})`;
                innerStyle.left = left;
                onClick = prev;
              } else {
                // 右侧图片
                innerStyle.transform = `scale(${scale}) translateY(${backDown})`;
                innerStyle.left = width - left - imageMeasurement.width * scale;
                onClick = next;
              }
              innerStyle.zIndex = backCount - distance; // 越靠中心的图片层级越高
              innerStyle.visibility = 'visible';
            }
          } else {
            // 不展示
            innerStyle.opacity = '0';
            innerStyle.left = width / 2 - imageMeasurement.width / 2;
          }

          return (
            <div key={index} style={innerStyle} className={style.screen} onClick={onClick}>
              <img style={{ width: '100%', height: '100%' }} src={screen.image} title={screen.title} />
            </div>
          );
        })}
        {showCount > 1 && (
          <div className={style.navigator}>
            {Array.from({ length: list.length }).map((s, i) => {
              return (
                <span
                  key={i}
                  className={classnames(style.navigator__factor, {
                    [style['navigator__factor--highlight']]: i === middle
                  })}
                  onMouseEnter={() => toIndex(i)}
                ></span>
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

function CarouselContainer(props: CarouselProps & { loading: boolean }) {
  const [imageMeasurement, setMeasurement] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!props.list.length) return;
    // 默认以第一张图片的尺寸为准
    const img = document.createElement('img');
    img.src = props.list[0].image;
    img.style.visibility = 'hidden';
    img.style.position = 'absolute';
    img.onload = () => {
      setMeasurement({ width: img.naturalWidth, height: img.naturalHeight });
      document.body.removeChild(img);
    };
    document.body.appendChild(img);
  }, [props.list]);

  const onClick = useCallback((id: string) => {
    getScreenLink(id).then((data) => {
      // window.open 传noopener会弹出新窗口
      const a = document.createElement('a');
      a.target = '_blank';
      a.rel = 'noopener';
      a.href = `/preview/${window.encodeURIComponent(data.url)}`;
      a.click();
    });
  }, []);

  if (props.loading) return null;

  if (!props.list.length) {
    const scale = 0.7;
    return (
      <div style={{ position: 'absolute', zIndex: 2, margin: 'auto', left: 0, right: 0, top: 0, bottom: 0 }}>
        <span className={classnames(style.handle_left)}></span>
        <span className={classnames(style.handle_right)}></span>
        <div
          className={classnames(style.screen, style['screen--empty'])}
          style={{ width: props.width * scale, height: props.height * scale }}
        >
          <span className={style['screen--empty__text']}>暂无可用大屏</span>
        </div>
      </div>
    );
  }

  if (imageMeasurement.width === 0 || imageMeasurement.height === 0) return null;

  return <_Carousel {...props} meaturement={imageMeasurement} onClick={onClick} />;
}

export const Carousel = connect<any, any, any, Cockpit.Store>((store) => ({
  list: store.screens.filter((s) => s.show),
  loading: store.screensLoading
}))(CarouselContainer);
